import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <footer className='footer' id='footer'>
      <Container>
        <Row>
          <Col xs={12} md={6} xl={3}>
            <h2 className='h2'>Öffnungszeiten</h2>
            <hr className='hr' />
            <p className='p'>
              Mo - Fr: 08:00 - 17:00 Uhr <br />
              sowie nach Vereinbarung
            </p>
          </Col>
          <Col xs={12} md={6} xl={3}>
            <h2 className='h2'>Kontakt</h2>
            <hr className='hr' />
            <p className='p telephone'>
              <span className='desc'>T:</span> +49 (0) 711 955 926 0
            </p>
            <p className='p fax'>
              <span className='desc'>F:</span> +49 (0) 711 955 926 99
            </p>
            <p className='p mail'>
              <span className='desc'>M:</span> info@ll-notare.de
            </p>
          </Col>
          <Col xs={12} md={6} xl={3}>
            <h2 className='h2'>Adresse</h2>
            <hr className='hr' />
            <address className='p'>
              <span className='state'>Carré Bad Cannstatt</span>
              <span className='street'>Kreuznacher Straße 68</span>
              <span className='city'>70372 Stuttgart</span>
            </address>
          </Col>
          <Col xs={12} md={6} xl={3}>
            <h2 className='h2'>Rechtliches</h2>
            <hr className='hr' />
            <ul className='ul'>
              <li className='li'>
                <HashLink to='/impressum/#' className='link'>
                  Impressum
                </HashLink>
              </li>
              <li className='li'>
                <HashLink to='/datenschutz/#' className='link'>
                  Datenschutzrichtlinien
                </HashLink>
              </li>
              <li className='li'>
                <HashLink to='/barrierefreiheit/#' className='link'>
                  Barrierefreiheit
                </HashLink>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
